const PrivacyPolicy = () => {
  return (
    <div className="section fade-in">
      <div className="container max-w-3xl">
        <p className="eyebrow mb-4 text-center block">Legal</p>
        <h1 className="mb-12 text-center">Privacy Policy</h1>

        <div className="prose prose-invert max-w-none">
          <p className="text-zinc-300 leading-relaxed text-lg">
            This Privacy Policy explains how Upside Down Capital ("we", "our", or "us") collects, uses, and protects your personal information in accordance with UK data protection laws, including the UK General Data Protection Regulation (UK GDPR).
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
          <p className="text-zinc-300 leading-relaxed">
            We may collect personal information such as your name, email address, IP address, and any details you submit through our forms or communications. We also collect limited technical data to improve our website experience.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. How We Use Your Data</h2>
          <p className="text-zinc-300 leading-relaxed">
            Your data may be used to respond to inquiries, manage communication, provide access to investor materials (for authorized users), improve our site, and comply with legal obligations.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. Legal Basis for Processing</h2>
          <p className="text-zinc-300 leading-relaxed">
            We process your data based on legitimate interests, consent where applicable, and compliance with regulatory requirements.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Data Sharing</h2>
          <p className="text-zinc-300 leading-relaxed">
            We do not sell your data. We may share your data with trusted service providers under strict confidentiality, solely for the purposes outlined in this policy.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Cookies</h2>
          <p className="text-zinc-300 leading-relaxed">
            Our website uses cookies to understand user behavior and improve performance. You may disable cookies in your browser settings. See our cookie banner for more details.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Data Retention</h2>
          <p className="text-zinc-300 leading-relaxed">
            We retain your data only for as long as necessary to fulfill the purposes stated or to meet legal and regulatory obligations.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Your Rights</h2>
          <p className="text-zinc-300 leading-relaxed">
            You have the right to access, correct, or delete your personal data, and to object to certain types of processing. To exercise your rights, contact us using the details below.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">8. Contact Information</h2>
          <p className="text-zinc-300 leading-relaxed">
            For questions or data-related requests, please reach out to: <a href="mailto:hello@udcapital.uk" className="text-white hover:underline">hello@udcapital.uk</a>.
          </p>

          <p className="text-sm text-zinc-500 mt-8">Last updated: July 2026</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
